var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./FullCalendar.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler?id=data-v-60a22b46!../../vue-loader/lib/selector?type=template&index=0!./FullCalendar.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-full-calendar/components/FullCalendar.vue
// module id = 514
// module chunks = 81